import { render, staticRenderFns } from "./RankingBar.vue?vue&type=template&id=ac8a67e6&scoped=true"
import script from "./RankingBar.vue?vue&type=script&lang=js"
export * from "./RankingBar.vue?vue&type=script&lang=js"
import style0 from "./RankingBar.vue?vue&type=style&index=0&id=ac8a67e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8a67e6",
  null
  
)

export default component.exports